import { selectExperiments } from './experiments';
import { VX_BOTTOM_NAVIGATION_EXPERIMENT } from '../../constants/experiments';
import { TAppState } from '../../types/appState';
import { EHostType } from '../../types/hostType';
import { isExperimentActive } from '../../utils/getExperiment';
import { hostTypeSelector } from '../hostTypeSelector';

export const selectIsBottomNavigationEnabled = (state: TAppState) => {
  const experiments = selectExperiments(state);
  const hostType = hostTypeSelector(state);

  return isExperimentActive(experiments, VX_BOTTOM_NAVIGATION_EXPERIMENT, 'B') && hostType !== EHostType.Frame;
};
